export default "__VITE_PUBLIC_ASSET__9e2745bf__"